import {
  SERVER_IN_MAINTENANCE,
  FETCH_LOGIN,
  FETCH_SIGNUP,
  FETCH_LOGIN_WITH_FB,
  FETCH_FORGET_PASSWORD,
  FETCH_SIGNUP_WITH_FB,
  LOGIN_FAILURE,
  API_START,
  SIGNUP_RESULT,
  WS_EVENT,
  CHAT,
  CLEAR_DROP_DOWN_ALERT_MESSAGE,
  SET_USER_FAILURE,
  SET_TEMPLATES_FAILURE,
  SET_TEMPLATE_DATES_FAILURE,
  SET_TEMPLATE_TIMES_FAILURE,
  SET_LOCATIONS_FAILURE,
  SET_GOOD_DEALS_CATEGORIES_FAILURE,
  SET_HOBBIES_FAILURE,
  SET_MY_CHAT_USERS_FAILURE,
  SET_COMMUNITY_DETAIL_FAILURE,
  FORGET_PASSWORD_FAILURE,
  FORGET_PASSWORD_RESULT,
  FETCH_LOGIN_AS_GUEST,
  FETCH_GET_GOOD_DEALS,
  FETCH_GET_GOOD_DEAL_DETAILS,
  SET_GOOD_DEAL_DETAILS_FAILURE,
  FETCH_GET_GOOD_DEALS_CATEGORIES,
  SET_GOOD_DEALS_FAILURE,
  SET_DROP_DOWN_ALERT_ERROR,
  FETCH_UPDATE_PROFILE,
  UPDATE_PROFILE_FAILURE,
  FETCH_GET_USER_PROFILE,
  FETCH_FAILURE,
  FETCH_BLOCK_USER,
  FETCH_UNBLOCK_USER,
  FETCH_FLAG_INAPPROPRIATE_CONTENT,
  FETCH_FLAG_INAPPROPRIATE_EVENT_CONTENT,
  FETCH_GET_COMMUNITY_CURRENT_METEO,
  FETCH_GET_CURRENT_METEO,
  FETCH_GET_FORECAST_METEO,
  CLEAR_DROP_DOWN_ALERT_ERROR,
  CLEAR_DROP_DOWN_ALERT_WARN,
  CLEAR_DROP_DOWN_ALERT_INFO,
  SET_DROP_DOWN_ALERT_INFO,
  SET_DROP_DOWN_ALERT_WARN,
  LIVE,
  SET_TEMPLATES,
  DELETE_USER_FAILURE,
  LOGOUT_FAILURE,
  SET_NOTIF_USER_TEMPLATES_FAILURE,
  FETCH_LOGOUT,
  FETCH_DELETE_USER,
  FETCH_SET_NOTIF_USER_TEMPLATES,
  FETCH_GET_NOTIF_USER_TEMPLATES,
  SET_PUBLISH_EVENT_FAILURE,
  FETCH_PUBLISH_EVENT,
  FETCH_GET_EVENT_INTERESTED_USERS,
  SET_EVENT_INTERESTED_USERS_FAILURE,
  HIDE_SPLASH_SCREEN,
  SET_CITY_COMMUNITIES_FAILURE,
  FETCH_DELETE_NOTIF_USER_TEMPLATE,
  FETCH_GET_NOTIF_STATUS,
  FETCH_SET_NOTIF_ALL,
  FETCH_SET_NOTIF_SELECTION,
  FETCH_EXIT_CHAT,
  SET_PROFILE_DETAILS,
  SET_IN_CHAT_WITH,
  SET_CHAT_EXIT_RESULT
} from "../actions/types";
import { Record } from "immutable";
import { t, getTranslatedProperty } from "../services/i18n";
import { PURPLE_COLOR } from "../styles/commonStyles";
import { getImage } from "../assets/Images";

const InitialState = new Record({
  errors: {},
  dropDownAlertInfo: null,
  dropDownAlertError: null,
  dropDownAutoClearAlertError: null,
  dropDownAutoClearAlertWarn: null,
  dropDownAutoClearAlertInfo: null,
  dropDownAlertMessage: null,
  isMaintenance: false,
  inChatWith: null,
  templates: {},
  splashScreenHide: false,
  logout: false,
  userId: null
});
const initialState = new InitialState();

export default function errorReducer(state = initialState, action = {}) {
  switch (action.type) {
    case API_START: {
      switch (action.payload) {
        case FETCH_LOGIN_AS_GUEST:
        case FETCH_LOGIN:
        case FETCH_SIGNUP:
        case FETCH_LOGIN_WITH_FB:
        case FETCH_FORGET_PASSWORD:
        case FETCH_SIGNUP_WITH_FB:
          return state
            .set("dropDownAlertError", null)
            .set("dropDownAlertInfo", null)
            .set("errors", {});
        case FETCH_GET_GOOD_DEALS:
        case FETCH_GET_GOOD_DEAL_DETAILS:
        case FETCH_GET_GOOD_DEALS_CATEGORIES:
        case FETCH_GET_USER_PROFILE:
        case FETCH_UPDATE_PROFILE:
        case FETCH_FLAG_INAPPROPRIATE_CONTENT:
        case FETCH_FLAG_INAPPROPRIATE_EVENT_CONTENT:
        case FETCH_BLOCK_USER:
        case FETCH_UNBLOCK_USER:
        case FETCH_GET_COMMUNITY_CURRENT_METEO:
        case FETCH_GET_CURRENT_METEO:
        case FETCH_GET_FORECAST_METEO:
        case FETCH_LOGOUT:
        case FETCH_DELETE_USER:
        case FETCH_GET_NOTIF_USER_TEMPLATES:
        case FETCH_SET_NOTIF_USER_TEMPLATES:
        case FETCH_PUBLISH_EVENT:
        case FETCH_DELETE_NOTIF_USER_TEMPLATE:
        case FETCH_GET_EVENT_INTERESTED_USERS:
        case FETCH_GET_NOTIF_STATUS:
        case FETCH_SET_NOTIF_ALL:
        case FETCH_SET_NOTIF_SELECTION:
        case FETCH_EXIT_CHAT:
          return state
            .set("dropDownAlertError", null)
            .set("dropDownAlertInfo", null);
        default:
          // Do nothing
          break;
      }
      break;
    }

    case HIDE_SPLASH_SCREEN:
      return state.set("splashScreenHide", true);

    case SERVER_IN_MAINTENANCE:
      return state.set("splashScreenHide", true).set("isMaintenance", true);

    case SET_IN_CHAT_WITH:
      return state.set("inChatWith", action.value);

    case SET_CHAT_EXIT_RESULT:
      return state.set("inChatWith", null);

    case SET_TEMPLATES:
      return state.set("templates", action.entities.templates);

    case SET_PROFILE_DETAILS:
      return state.set("userId", action.payload._id);

    case WS_EVENT:
      if (action.payload.type === CHAT) {
        if (
          action.payload.from._id !== state.inChatWith &&
          action.payload.from._id !== state.userId &&
          action.payload.eventId !== state.inChatWith
        ) {
          const {
            _id,
            pseudo,
            firstname,
            photoUri,
            gender
          } = action.payload.from;
          const message =
            pseudo.indexOf("@") < 0
              ? {
                  title: "Message" + t("infos:from") + pseudo,
                  message: action.payload.text,
                  source: photoUri
                    ? photoUri
                    : gender === "F"
                    ? getImage("avatarF")
                    : getImage("avatar"),
                  eventId: action.payload.eventId,
                  pseudo,
                  from: pseudo
                }
              : {
                  title: "Message" + t("infos:from") + firstname,
                  message: action.payload.text,
                  source: photoUri
                    ? photoUri
                    : gender === "F"
                    ? getImage("avatarF")
                    : getImage("avatar"),
                  id: _id,
                  eventId: action.payload.eventId,
                  from: firstname
                };
          return state.set("dropDownAlertMessage", message);
        }
      } else if (action.payload.type === LIVE && action.payload.alert) {
        const message = {
          title: "Post" + t("infos:from") + action.payload.userId.pseudo,
          message: state.templates[action.payload.templateId]
            ? getTranslatedProperty(
                state.templates[action.payload.templateId],
                "description"
              )
            : "",
          activeStatusBarBackgroundColor: PURPLE_COLOR,
          source: action.payload.userId.photoUri
            ? action.payload.userId.photoUri
            : gender === "F"
            ? getImage("avatarF")
            : getImage("avatar"),
          id: action.payload.userId._id,
          from: action.payload.userId.pseudo
        };
        return state.set("dropDownAlertMessage", message);
      }
      break;

    case CLEAR_DROP_DOWN_ALERT_MESSAGE:
      return state.set("dropDownAlertMessage", null);

    case SIGNUP_RESULT:
      if (action.payload.message === "New account created") {
        return state.set("dropDownAlertInfo", "popup1");
      } else {
        return state.set("dropDownAlertInfo", "popup2");
      }

    case FORGET_PASSWORD_RESULT:
      return state.set("dropDownAlertInfo", "popup3");

    case FORGET_PASSWORD_FAILURE:
      if (("" + action.payload).endsWith("404")) {
        return state.set("dropDownAlertInfo", "unknownemail");
      }
      return state.set("dropDownAlertError", "unexpectederror");

    case SET_DROP_DOWN_ALERT_ERROR:
      return state
        .set("splashScreenHide", true)
        .set("dropDownAutoClearAlertError", action.error);

    case CLEAR_DROP_DOWN_ALERT_ERROR:
      return state.set("dropDownAutoClearAlertError", null);

    case SET_DROP_DOWN_ALERT_WARN:
      return state
        .set("splashScreenHide", true)
        .set("dropDownAutoClearAlertWarn", action.warn);

    case CLEAR_DROP_DOWN_ALERT_WARN:
      return state.set("dropDownAutoClearAlertWarn", null);

    case SET_DROP_DOWN_ALERT_INFO:
      return state
        .set("splashScreenHide", true)
        .set("dropDownAutoClearAlertInfo", action.info);

    case CLEAR_DROP_DOWN_ALERT_INFO:
      return state.set("dropDownAutoClearAlertInfo", null);

    case SET_USER_FAILURE:
    case SET_TEMPLATES_FAILURE:
    case SET_TEMPLATE_DATES_FAILURE:
    case SET_TEMPLATE_TIMES_FAILURE:
    case SET_LOCATIONS_FAILURE:
    case SET_GOOD_DEALS_CATEGORIES_FAILURE:
    case SET_HOBBIES_FAILURE:
    case SET_MY_CHAT_USERS_FAILURE:
    case SET_COMMUNITY_DETAIL_FAILURE:
    case SET_CITY_COMMUNITIES_FAILURE:
      return state
        .set("splashScreenHide", true)
        .setIn(["errors", action.type], action.payload)
        .set("dropDownAlertError", "errorloadingdata")
        .set("logout", true);

    case SET_GOOD_DEAL_DETAILS_FAILURE:
    case SET_GOOD_DEALS_FAILURE:
    case SET_GOOD_DEALS_CATEGORIES_FAILURE:
    case UPDATE_PROFILE_FAILURE:
    case FETCH_FAILURE:
    case DELETE_USER_FAILURE:
    case LOGOUT_FAILURE:
    case SET_NOTIF_USER_TEMPLATES_FAILURE:
    case SET_PUBLISH_EVENT_FAILURE:
    case SET_EVENT_INTERESTED_USERS_FAILURE:
      const errorMsg =
        action.payload && action.payload.message ? action.payload.message : "";
      if (errorMsg === "Network Error") {
        return state
          .set("splashScreenHide", true)
          .set("dropDownAlertError", "networkerror");
      } else {
        return state
          .set("splashScreenHide", true)
          .set("dropDownAlertError", "unexpectederror");
      }

    case LOGIN_FAILURE: {
      const errorMsg =
        action.payload && action.payload.message ? action.payload.message : "";
      if (errorMsg === "Network Error") {
        return state.set("dropDownAlertError", "networkerror");
      }
      if (errorMsg.endsWith("400") || errorMsg.endsWith("401")) {
        break;
      } else if (errorMsg.endsWith("403")) {
        return state.set("dropDownAlertError", "unauthorized");
      } else if (errorMsg.endsWith("404")) {
        return state.set("dropDownAlertError", "unknown");
      } else if (errorMsg.endsWith("406")) {
        return state.set("dropDownAlertInfo", "popup2");
      } else if (errorMsg.endsWith("423")) {
        return state.set("dropDownAlertInfo", "popup4");
      } else {
        return state.set("dropDownAlertError", "unexpectederror");
      }
    }
  }
  return state;
}
